<template>
  <div
    class="questionOrderButton"
    style="position: absolute; top:0; right:15px;"
  >
    <b-link
      v-if="items && items.length >= 2"
      @click="reOrder()"
    >
      <small>{{ $t('Re-Order') }}</small> <feather-icon
        icon="ShuffleIcon"
        size="12"
      />
    </b-link>
    <modal-question-order
      :id="id"
      :key="'modalQuestionOrder'"
      :questions="items"
      :options="options"
      @submit="saveQuestionOrder"
    />

  </div>
</template>

<script>
import ModalQuestionOrder from '@/layouts/components/ModalQuestionOrder.vue'

import {
  BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BLink,
    ModalQuestionOrder,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      series: [this.statistic],
    }
  },
  computed: {
    items: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      },
    },
  },
  methods: {
    reOrder() {
      this.$bvModal.show(`modal-question-order_${this.id}`)
    },
    saveQuestionOrder(orderedList) {
      this.items = orderedList
      this.$bvModal.hide(`modal-question-order_${this.id}`)
    },
  },
}
</script>
